import { useEffect } from "react";

const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

const useMobileDrawerInteractions = ({
  active,
  drawerRef,
  toggleRef,
  onClose
}) => {
  useEffect(() => {
    if (!active || !drawerRef.current) return undefined;

    const previousOverflow = document.body.style.overflow;
    const drawer = drawerRef.current;
    const drawerItems = () =>
      Array.from(drawer.querySelectorAll(FOCUSABLE_SELECTOR));
    const focusableItems = () =>
      [toggleRef.current, ...drawerItems()].filter(Boolean);

    document.body.style.overflow = "hidden";
    drawerItems()[0]?.focus();

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
        toggleRef.current?.focus();
        return;
      }

      if (event.key !== "Tab") return;

      const items = focusableItems();
      const first = items[0];
      const last = items[items.length - 1];
      if (!first || !last) return;

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [active, drawerRef, onClose, toggleRef]);
};

export default useMobileDrawerInteractions;
